module.exports = __webpack_public_path__ + "img/success_OLD_6.acac1b2f.gif";